import Cookies from 'js-cookie';

export const TOKEN_COOKIE = 'cognito_access_token';

const COGNITO_LOCAL_STORAGE_PREFIX = 'CognitoIdentityServiceProvider.';

const isLocalhostHost = (hostname: string) =>
	hostname === 'localhost' ||
	hostname === '127.0.0.1' ||
	hostname === '[::1]';

export const getAuthCookieAttributes = () => {
	const { hostname, protocol } = window.location;

	return {
		...(isLocalhostHost(hostname) ? {} : { domain: hostname }),
		path: '/',
		sameSite: 'strict' as const,
		secure: protocol === 'https:',
	};
};

export const getCognitoCookieStorage = () => {
	const { hostname, protocol } = window.location;

	return {
		domain: hostname,
		path: '/',
		expires: 30,
		sameSite: 'strict' as const,
		secure: protocol === 'https:',
	};
};

export const setTokenCookie = (token: string) => {
	Cookies.set(TOKEN_COOKIE, token, getAuthCookieAttributes());
};

export const removeTokenCookie = () => {
	const { domain, path } = getAuthCookieAttributes();
	Cookies.remove(TOKEN_COOKIE);
	Cookies.remove(TOKEN_COOKIE, { path });
	if (domain) Cookies.remove(TOKEN_COOKIE, { domain, path });
};

export const getTokenCookie = () => Cookies.get(TOKEN_COOKIE);

export const migrateCognitoLocalStorageToCookies = () => {
	try {
		const cookieOptions = getCognitoCookieStorage();
		const keysToRemove: string[] = [];

		for (let i = 0; i < localStorage.length; i += 1) {
			const key = localStorage.key(i);
			if (!key?.startsWith(COGNITO_LOCAL_STORAGE_PREFIX)) continue;

			const value = localStorage.getItem(key);
			if (!value) {
				keysToRemove.push(key);
				continue;
			}

			Cookies.set(key, value, cookieOptions);
			if (Cookies.get(key)) keysToRemove.push(key);
		}

		keysToRemove.forEach(key => localStorage.removeItem(key));
	} catch {
		// localStorage pode estar indisponível (modo privado / políticas do browser)
	}
};
